module.exports = __webpack_public_path__ + "static/media/golf-carousel.2a8fc258.jpg";